import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown w-250px w-md-600px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "px-7 py-5" }
const _hoisted_3 = { class: "fs-5 text-dark fw-bolder" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_5 = { class: "px-7 py-5 mh-400px scroll-y" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6 form-group mb-7" }
const _hoisted_8 = { class: "form-label fw-bold" }
const _hoisted_9 = { class: "col-md-6 form-group mb-7" }
const _hoisted_10 = { class: "form-label fw-bold" }
const _hoisted_11 = { class: "col-md-6 form-group mb-7" }
const _hoisted_12 = { class: "form-label fw-bold" }
const _hoisted_13 = { class: "col-md-6 form-group mb-7" }
const _hoisted_14 = { class: "form-label fw-bold" }
const _hoisted_15 = { class: "col-md-6 form-group mb-7" }
const _hoisted_16 = { class: "form-label fw-bold" }
const _hoisted_17 = { class: "col-md-6 form-group mb-7" }
const _hoisted_18 = { class: "form-label fw-bold" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_20 = { class: "px-7 py-5 d-flex justify-content-end gap-2" }
const _hoisted_21 = { class: "svg-icon svg-icon-3" }
const _hoisted_22 = {
  type: "submit",
  class: "btn btn-primary",
  "data-kt-menu-dismiss": "true"
}
const _hoisted_23 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
      model: _ctx.formData
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t("common.filterOptions")), 1)
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.t("datevBalance.reportDateStart")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "document_time_start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    class: "w-100",
                    modelValue: _ctx.formData.document_time_start,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.document_time_start) = $event)),
                    type: "date",
                    placeholder: _ctx.t('common.pickDate'),
                    format: "DD.MM.YYYY"
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.t("datevBalance.reportDateEnd")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "document_time_end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    class: "w-100",
                    modelValue: _ctx.formData.document_time_end,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.document_time_end) = $event)),
                    type: "date",
                    placeholder: _ctx.t('common.pickDate'),
                    format: "DD.MM.YYYY"
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("datevBalance.reportKw")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "report_kw" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    class: "w-100",
                    modelValue: _ctx.formData.report_kw,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.report_kw) = $event)),
                    filterable: "",
                    clearable: "",
                    loading: _ctx.options.yearLoading,
                    placeholder: _ctx.t('common.plsSelect')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.kwOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item,
                          label: item,
                          value: item
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "loading", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("datevBalance.reportYear")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "report_year" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    class: "w-100",
                    modelValue: _ctx.formData.report_year,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.report_year) = $event)),
                    filterable: "",
                    clearable: "",
                    loading: _ctx.options.yearLoading,
                    placeholder: _ctx.t('common.plsSelect')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.yearOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item,
                          label: item,
                          value: item
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "loading", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("documents.type")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "report_type" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    class: "w-100",
                    modelValue: _ctx.formData.report_type,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.report_type) = $event)),
                    filterable: "",
                    clearable: "",
                    loading: _ctx.options.typeLoading,
                    placeholder: _ctx.t('common.plsSelect')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.typeOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.report_type,
                          label: item.name,
                          value: item.report_type
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "loading", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("common.status")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "status" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    class: "w-100",
                    modelValue: _ctx.formData.status,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.status) = $event)),
                    filterable: "",
                    clearable: "",
                    multiple: "",
                    placeholder: _ctx.t('common.plsSelect')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.statusOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("button", {
            type: "reset",
            class: "btn btn-light",
            "data-kt-menu-dismiss": "true",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleReset && _ctx.handleReset(...args)))
          }, [
            _createElementVNode("span", _hoisted_21, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr059.svg" })
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.t("common.reset")), 1)
          ]),
          _createElementVNode("button", _hoisted_22, [
            _createElementVNode("span", _hoisted_23, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.t("common.apply")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}